module.exports = __webpack_public_path__ + "static/media/ticket.ab647641.png";